import React from "react";
import { useVehicleData } from "../../hooks/useVehicleData";
import Form from "./Form";
import { getDataFresh } from "../../state/selectors";
import { useSelector } from "react-redux";
import { useInspectionTypeData } from "../../hooks/useInspectionTypeData";
import { useVehicleTypeData } from "../../hooks/useVehicleTypeData";
import { useDefaultsData } from "../../hooks/useDefaultsData";
import {useKeysData} from "../../hooks/useKeysData";
import {useVehicleMakeData} from "../../hooks/useVehicleMakeData";
import {useVehicleModelData} from "../../hooks/useVehicleModelData";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import {useTrackingOptionsData} from "../../hooks/useTrackingOptionsData";
import {useUtilData} from "../../hooks/useUtilData";

function VehicleForm(props) {
  let dataFresh = useSelector(getDataFresh);
  let vehicle_loaded = useVehicleData(props.match.params.vehicle, dataFresh);
  let inspection_types_loaded = useInspectionTypeData({page_size:100});
  // let vehicle_types_loaded = useVehicleTypeData({page_size: 100});
  let app_defaults_loaded = useDefaultsData({});
  let keys_loaded = useKeysData({})
  // const vehicle_make_loading = useVehicleMakeData({page_size: 100}, dataFresh);
  // const vehicle_model_loading = useVehicleModelData({page_size: 1000}, dataFresh);
  // const departmentsLoaded = useDepartmentsData({}, dataFresh);
  // const trackingOptionsLoaded = useTrackingOptionsData({}, dataFresh);
  const utilsLoaded = useUtilData({service_pack: 1, department: 1, tracking: 1, type: 1, key: 1, make: 1, model: 1});
  return (
    <Form
      loaded={
        vehicle_loaded &&
        inspection_types_loaded &&
        app_defaults_loaded &&
        utilsLoaded
      }
      endpoint={props.endpoint}
      history={props.history}
    />
  );
}

export default VehicleForm;
